import Alpine from 'alpinejs'

Alpine.store('Backdrop', {
  isVisible: false,

  show() {
    this.isVisible = true
  },

  hide() {
    this.isVisible = false
  },

  toggle() {
    this.isVisible = !this.isVisible
  },
})
